
import { useFormik } from "formik";
import { useState } from "react";
import { ToastContainer } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import * as Yup from 'yup';
import { jobService } from "services";
import { useNavigate } from "react-router-dom";
import useCurrentUser from "hooks/useCurrentUser";

function RaseandDispute(props) {
  const { show, handleClose, id, setJobDetails, jobDetails } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([])
  const [textarea, setTextArea] = useState('')
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { user: currentUser } = useCurrentUser();
  const { isStripeConnected } = currentUser || {};

  const formik = useFormik({
    initialValues: {
      description: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      description: Yup.string().required("Please enter description")
    }),
    onSubmit: async (values) => {
      const payload = {
        "jobId": id,
        "description": values.description
      }
      try {
        const response = await jobService.raiseDispute(payload)
        if (response?.data?.success === false) {
          toast.error(response?.data?.message)
        }
        else {
          handleClose();
          toast.success(response?.data?.message)
          setJobDetails({
            ...jobDetails,
            isDisputed: true
          })
          if(isStripeConnected === false){
            navigate('/connect');
          }
        }
      }
      catch (err) {
        console.log(err?.response?.data?.meassage)
      }
    },
  });

  return (
    <>
      <Modal
        show={show}
        className="modal-common verify-otp-modal"
        onHide={handleClose}
      >
        <Modal.Header closeButton>Raise a Dispute</Modal.Header>
        <Modal.Body>
          <form >
            <div className="head-verify">
              <p className="mb-0">
                Please be as detailed as possible. What did you expect and what
                happened instead?
              </p>
            </div>
            <div >
              <div className="textrea-overlay w-100">
              <textarea
                className="form-control"
                rows="8"
                onBlur={formik.handleBlur}
                value={formik.values.description}
                id="description"
                onChange={formik.handleChange}
                maxLength={1000}

              ></textarea>
              </div>
              <label className="d-block text-end pt-1 pe-1">{formik.values.description.length}/1000</label>
              {formik.touched.description && formik.errors.description ? (
                <span className="text-danger">{formik.errors.description}</span>
              ) : null}
            </div>
            <button
              onClick={() => {
                setIsLoading(true);
                setTimeout(() => {

                  setIsLoading(false);
                  formik.handleSubmit();
                }, 2000);
              }}
              disabled={isLoading}
              className="btn d-inline-block btn-primary modal-blue-btn text-capitalize w-100 text-white"
            >
              {isLoading ? "Loading..." : "Submit"}
            </button>
          </form>
        </Modal.Body>
      </Modal>
      <ToastContainer />
    </>
  );
}

export default RaseandDispute;
